import {
  Home as HomeIcon,
  // AccountCircle as AccountIcon,
  // Settings as SettingsIcon,
  Star as StarIcon,
} from "@mui/icons-material";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DRAWER_WIDTH = 200;

interface MenuItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  path: string;
  disabled?: boolean;
}

const menuItems: MenuItem[] = [
  {
    id: "home",
    label: "Home",
    icon: <HomeIcon />,
    path: "/",
  },
  {
    id: "subscription",
    label: "Subscription",
    icon: <StarIcon />,
    path: "/subscription",
  },
  /*
  {
    id: "account",
    label: "Account",
    icon: <AccountIcon />,
    path: "/account",
  },
  {
    id: "settings",
    label: "Settings",
    icon: <SettingsIcon />,
    path: "/settings",
  },
  */
];

interface LeftMenuProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

const LeftMenu: React.FC<LeftMenuProps> = ({ mobileOpen, onMobileClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    navigate(path);
    if (onMobileClose) {
      onMobileClose();
    }
  };

  const drawer = (
    <Box>
      <List sx={{ py: 0 }}>
        {menuItems.map((item) => (
          <ListItem key={item.id} disablePadding sx={{ mb: 0.25 }}>
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => handleNavigation(item.path)}
              disabled={item.disabled}
              sx={{
                py: 0.5,
                px: 1.5,
                borderRadius: 0.5,
                mx: 0.75,
                minHeight: 36,
                "&.Mui-selected": {
                  backgroundColor: "primary.light",
                  color: "primary.contrastText",
                  "&:hover": {
                    backgroundColor: "primary.main",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "inherit",
                  },
                },
                "&.Mui-disabled": {
                  opacity: 0.4,
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 28,
                  color: location.pathname === item.path ? "inherit" : "text.secondary",
                  "& .MuiSvgIcon-root": {
                    fontSize: "1rem",
                  },
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: "0.75rem",
                  fontWeight: location.pathname === item.path ? 600 : 500,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 } }}
    >
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: DRAWER_WIDTH,
            backgroundColor: "background.paper",
            borderRight: 1,
            borderColor: "divider",
            p: 1,
          },
        }}
      >
        {drawer}
      </Drawer>

      {/* Desktop drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: DRAWER_WIDTH,
            height: "calc(100vh - 48px)",
            position: "fixed",
            top: 48, // Below the AppBar
            left: 0,
            zIndex: 1000,
            backgroundColor: "background.paper",
            borderRight: 1,
            borderColor: "divider",
            p: 1,
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export { DRAWER_WIDTH };
export default LeftMenu;
